import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import { TAX_DETAILS_MESSAGES } from "./TaxDetails.messages";

/** Renders the Tax Details section heading. */
const TaxDetailsHeader = () => (
  <Text element="h5" typeface="body-3" className="tw-m-0">
    <FormattedMessage {...TAX_DETAILS_MESSAGES.sectionHeading} />
  </Text>
);

export { TaxDetailsHeader };
